import React from 'react'

function RenderOption({ option, filter, onChange, propClass, propClassInput }) {

    if (option) {
        if (option.type) {

            switch (option.type) {
                case 'text':
                    return (
                        <div className={'form-group ' + propClass}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <label>{option.name}</label>
                            </div>
                            <input name={'meta_data[' + option.id + ']'} defaultValue={filter && filter[`meta_data[${option.id}]`]} onChange={onChange} type="text" className={'form-control ' + propClassInput} />

                        </div>
                    )
                case 'number':
                    return (
                        <div className={'form-group ' + propClass}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <label>{option.name}</label>
                            </div>
                            <input name={'meta_data[' + option.id + ']'} defaultValue={filter && filter[`meta_data[${option.id}]`]} onChange={onChange} type="number" className={'form-control ' + propClassInput} />

                        </div>
                    )
                case 'price':
                    return (
                        <div className={'form-group ' + propClass}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <label>{option.name}</label>
                            </div>
                            <input name={'meta_data[' + option.id + ']'} defaultValue={filter && filter[`meta_data[${option.id}]`]} onChange={
                                (e) => {
                                    let str = e.target.value;
                                    str = String(str).replace(/[^0-9]/g, '');
                                    onChange({ target: { name: e.target.name, value: str } })
                                    e.target.value = (Number(str)).toLocaleString(undefined, { maximumFractionDigits: 0 })

                                }} type="text" className={'form-control ' + propClassInput} />

                        </div>
                    )
                case 'select':
                    const arrayValue = option.value.toString().split(',');
                    return (
                        <div className={'form-group ' + propClass}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <label>{option.name}</label>
                            </div>
                            <select name={'meta_data[' + option.id + ']'} onChange={onChange} className={'form-control ' + propClassInput}>
                                <option value="">انتخاب کنید</option>
                                {arrayValue.map((val, i) => <option selected={filter && filter[`meta_data[${option.id}]`] == val ? true : false} key={i} value={val}>{val}</option>)}
                            </select>

                        </div>
                    )
                case 'checkbox':
                    const arrayValue2 = option.value.toString().split(',');
                    return (
                        <div className={'form-group ' + propClass}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <label>{option.name}</label>

                            </div>
                            <div className='row'>
                                {
                                    arrayValue2.map((val) => (
                                        <div className={'form-group ' + propClass}>
                                            <input className='mx-1' type="checkbox" checked={filter && filter[`meta_data[${option.id}]`] == val ? true : false} value={val} name={'meta_data[' + option.id + '][]'} onChange={onChange} />
                                            <label>{val}</label>
                                        </div>
                                    ))
                                }
                            </div>

                        </div>
                    )
                case 'radio':
                    const arrayValue3 = option.value.toString().split(',');
                    return (
                        <div className={'form-group ' + propClass}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <label>{option.name}</label>

                            </div>
                            <div className='row'>
                                {
                                    arrayValue3.map((val) => (
                                        <div className={'form-group ' + propClass}>
                                            <input className='mx-1' type="radio" checked={filter && filter[`meta_data[${option.id}]`] == val ? true : false} value={val} name={'meta_data[' + option.id + ']'} onChange={onChange} />
                                            <label>{val}</label>
                                        </div>
                                    ))
                                }
                            </div>

                        </div>
                    )
                default:
                    return null
            }

        }
    }
    return null
}

export default RenderOption